import * as React from 'react'
import { Box, Paper, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'

type SectionCardProps = {
	title: string
	children: React.ReactNode
	rightAdornment?: React.ReactNode
}

export function SectionCard({ title, children, rightAdornment }: SectionCardProps) {
	return (
		<Paper
			variant='outlined'
			sx={{
				width: '100%',
				// Slightly tinted surface so the form "panel" is clearly visible on the page.
				bgcolor: (theme) =>
					alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.12 : 0.06),
				borderColor: 'divider',
				boxShadow: (theme) =>
					`0 10px 28px ${alpha(
						theme.palette.common.black,
						theme.palette.mode === 'dark' ? 0.35 : 0.14,
					)}`,
			}}
		>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					bgcolor: 'primary.main',
					color: 'primary.contrastText',
					px: 1.5,
					py: 0.75,
				}}
			>
				<Typography sx={{ fontWeight: 700, fontSize: '0.85rem', letterSpacing: 0.3 }}>
					{title.toUpperCase()}
				</Typography>
				{rightAdornment}
			</Box>
			<Box
				sx={{
					p: 1.5,
					bgcolor: (theme) =>
						alpha(theme.palette.background.paper, theme.palette.mode === 'dark' ? 0.88 : 0.92),
				}}
			>
				{children}
			</Box>
		</Paper>
	)
}
